module.exports = __webpack_public_path__ + "ipetbooking/admin/img/card_icon_master.a6d92557.svg";